import type { FaireBrandEntity } from "../../entity_types/brand";

// The Good Book Company (b_8zv2s38j7b). Identity metadata from
// ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2 "The Good Book Company"
// real-brand variant (advertiser -7626954770814929455).
export const b_8zv2s38j7b: FaireBrandEntity = {
  token: "b_8zv2s38j7b",
  type: "brand",
  name: "The Good Book Company",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 214,
  isTopShop: true,
  isInsider: true,
  description:
    "The Good Book Company publishes gospel-centered books, Bible studies, devotionals, and gifts to help people explore and grow in their faith.",
  meta: {
    source: "snowflake",
    importedAt: "2026-08-04T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
